export default "__VITE_ASSET__DcPFlVo7__"